import styled, { keyframes } from 'styled-components'

export const pulseAnimation = keyframes`
  0% {
    opacity: .6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: .6;
 }
`

const PulsingGrey = styled.div`
  animation: ${pulseAnimation} 1.5s infinite;
  background-color: #eee;
`

export default PulsingGrey
